export const PolCarousel = require('./PolCarousel').default,
  { PolSelection } = require('./PolSelection'),
  Loading = require('./Loading').default;
